<template>
  <v-alert
    :type="item.color"
    border="left"
    prominent
    transition="fade-transition"
    dismissible
    class="mb-1"
    data-test-id="success-item"
    @input="remove"
  >
    <template #prepend>
      <v-icon large>
        {{ item?.icon || 'mdi-check-circle' }}
      </v-icon>
    </template>
    <div class="text-break" style="max-width: 300px" :data-test-id="$tid('success-item', 'message')">
      {{ item.message }}
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'pinia';
import { useSuccessStore } from '@/store/stores';

export default defineComponent({
  name: 'SuccessItem',
  props: {
    item: {
      type: Object,
      default: () => ({
        message: 'Успешно сохранено!',
        color: 'success',
      }),
    },
    index: {
      type: Number,
    },
  },
  methods: {
    ...mapActions(useSuccessStore, ['removeSuccess']),
    remove() {
      this.removeSuccess(this.index);
    },
  },
});
</script>
<style scoped>
.v-alert__content {
  z-index: 9999 !important;
}
/*
    .v-alert--text:before {
        background-color: #000!important;
        opacity: 0.85!important;
    }
*/
</style>
